import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { getFileDownloadUrl } from "../../../../api/firebase/firestoreService";
import { ToastMessages } from "../../../../enums/toastMessages";
import { logError } from "../../../../utils/customLogger";
import { TEMPLATE_PATH } from "../constant/templateFilePath";

// Path to the template file in Firebase Storage

export const useTemplateDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTemplate = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    try {
      // Get the download URL from Firebase Storage
      const downloadUrl = await getFileDownloadUrl(TEMPLATE_PATH);

      if (!downloadUrl) {
        toast.error(ToastMessages.TEMPLATE_DOWNLOAD_ERROR);
        return;
      }

      // Fetch the file
      const response = await fetch(downloadUrl);

      if (!response.ok) {
        toast.error(ToastMessages.TEMPLATE_DOWNLOAD_ERROR);
        return;
      }

      const blob = await response.blob();

      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger download
      const link = document.createElement("a");
      link.href = url;
      // Extract filename from path or use default
      const filename =
        TEMPLATE_PATH.split("/").pop() || "astera-primarycare-template.csv";
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(ToastMessages.TEMPLATE_DOWNLOAD_SUCCESS);
    } catch (error) {
      logError(error as Error, "Error downloading template");
      toast.error(ToastMessages.TEMPLATE_DOWNLOAD_ERROR);
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadTemplate,
    isDownloading,
  };
};
